import { LoadableLazy } from '@confluence/loadable';

export const LazyForgeContentTools = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ForgeContentTools" */ '../src/ForgeContentTools.tsx'))
			.ForgeContentTools,
});
